import { getLang } from './i18n';
import { authFetch } from './auth';

const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:8100/api' : '/api';

// Generates the PDF from the PROVIDED DATA (even if not saved yet) and downloads it.
// path: 'onav' | 'aspi' | 'pairings'. chartSelector: selector of the SVG to embed
// (the AIS graphic sheet of a Mercadini pairing): it is read from the page as it is displayed.
export async function exportPdf({ path, data, chartSelector, errorMessage }) {
  const chart_svg = chartSelector ? document.querySelector(chartSelector)?.outerHTML : undefined;
  try {
    const res = await fetch(`${API_URL}/${path}/pdf`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lang: getLang(), data, chart_svg }),
    });
    if (!res.ok) throw new Error(String(res.status));
    const blob = await res.blob();
    const name = /filename="([^"]+)"/.exec(res.headers.get('Content-Disposition') || '')?.[1] || `${path}.pdf`;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
    return true;
  } catch {
    if (errorMessage) alert(errorMessage);
    return false;
  }
}

// Downloads a PDF generated from SAVED data (GET): `path` is relative to the API root, e.g. 'coffee/<id>/pdf'
// or 'products/<id>/report/pdf'. The request carries the user's token (private sheets) and the current language.
// Returns { ok: true } or { ok: false, message } where message is the API's localized error text, if it sent one.
export async function downloadPdf({ path, fallbackName }) {
  try {
    const res = await authFetch(`${API_URL}/${path}${path.includes('?') ? '&' : '?'}lang=${getLang()}`, { headers: { Accept: 'application/pdf' } });
    if (!res) return { ok: false };
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      return { ok: false, message: body && body.detail };
    }
    const blob = await res.blob();
    const name = /filename="([^"]+)"/.exec(res.headers.get('Content-Disposition') || '')?.[1] || fallbackName || 'document.pdf';
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
    return { ok: true };
  } catch {
    return { ok: false };
  }
}
